// @ts-nocheck
import { kanbanBaseUrl } from '../apiUrls';
import type { Dispatch } from 'redux';
import axios from '../../../../services/api';
import { KanbanAction, KanbanActions } from '../types/kanban';

export const fetchKanbanRoutes = (nodeKey: string) => {
  return async (dispatch: Dispatch<KanbanAction>) => {
    try {
      dispatch({ type: KanbanActions.FETCH_KANBAN_ROUTES });
      const response = await axios.get(kanbanBaseUrl + 'GetKanbanRoutes', {
        params: { nodeKey: nodeKey },
      });
      const data = response.data;
      dispatch({
        type: KanbanActions.FETCH_KANBAN_ROUTES_SUCCESS,
        payload: data?.Code === 1 || data?.code === 1 ? data.data : null,
      });
    } catch {
      // Routes config is optional — board still loads without it
      dispatch({
        type: KanbanActions.FETCH_KANBAN_ROUTES_SUCCESS,
        payload: null,
      });
    }
  };
};
